import PropTypes from 'prop-types'

import { electricNotificationsBatteryLevelBasedConfigPropType } from './electric-notifications-battery-level-based-prop-type'
import { electricNotificationsChargingFailedConfigPropType } from './electric-notifications-charging-failed-prop-type'

/**
 * @typedef {Object} ElectricNotificationsAccountConfig
 *
 * @property {ElectricNotificationsChargingFailedConfig} chargingFailed - The charging failed notification
 * @property {ElectricNotificationsBatteryLevelBasedConfig} chargingFinished - The charging finished notification
 * @property {ElectricNotificationsBatteryLevelBasedConfig} lowBattery - The low battery notification
 */
export const electricNotificationsAccountConfigPropType = PropTypes.shape({
    chargingFailed: electricNotificationsChargingFailedConfigPropType.isRequired,
    chargingFinished: electricNotificationsBatteryLevelBasedConfigPropType.isRequired,
    lowBattery: electricNotificationsBatteryLevelBasedConfigPropType.isRequired
})
